module.exports = __webpack_public_path__ + "static/img/modal-bg.3735432f.png";